import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import DocumentTitle from 'react-document-title';

import './index.css';
import {App} from './App';
import {SurveyCreatorWidget} from './SurveyCreatorWidget';
import SurveyResult from './SurveyResult';
import SurveyThankYou from './SurveyThankYou';
import {SurveyCreatorLogger} from "./SurveyCreatorLogger";
import { Provider } from 'react-redux';
import { store } from './store';


ReactDOM.render((
  <Provider store={store}>
    <DocumentTitle title='UpMyShop! Surveys'>
      <BrowserRouter>
        <Switch>
          <Route exact path="/" render={() => ""} />
          <Route exact path="/ping" render={() => "OK"} />
          <Route path="/survey-editor/login/:tkn/:surveyid" component={SurveyCreatorLogger} />
          <Route path="/survey-editor/:surveyid" component={SurveyCreatorWidget} />
          <Route path="/survey/result/:postid" component={SurveyResult} />
          <Route path="/survey/thankyou/:postid" component={SurveyThankYou} />
          <Route path="/:surveyslug" component={App} />
        </Switch>
      </BrowserRouter>
    </DocumentTitle>
  </Provider>

), document.getElementById('root'));
